import axios from '@/api/axios'

const createAnalytics = (analytic) => {
  return axios.post('/analytics', analytic)
}

const getAnalytics = () => {
  return axios.get('/analytics')
}

const getAnalyticsByParams = (params) => {
  return axios.get(`/analytics${params}`).then((response) => response.data)
}

const getAnalytic = (type, id, params = null) => {
  return axios
    .get(`/analytics/${type}/${id}/info`, {params})
    .then((response) => response.data)
}

const updateAnalytic = (id, planInput) => {
  return axios.put(`/analytics/${id}`, planInput)
}

const deleteAnalytic = (id) => {
  return axios.delete(`/analytics/${id}`)
}

export default {
  createAnalytics,
  getAnalytic,
  getAnalyticsByParams,
  getAnalytics,
  updateAnalytic,
  deleteAnalytic,
}
